module.exports = __webpack_public_path__ + "static/media/volume.c4107410.svg";